import { sendEmail } from './resend';

// Re-export everything from resend client
export * from './resend';

// Export template components
export { default as WelcomeEmail } from './templates/welcome';
export { default as InvitationEmail } from './templates/invitation';
export { default as ScheduleNotification } from './templates/schedule-notification';

// Export helper functions for sending specific types of emails
export async function sendWelcomeEmail(to: string, name: string, teamName: string) {
  return sendEmail({
    to,
    subject: 'Welcome to ShiftNapse',
    templateName: 'welcome',
    templateData: { name, teamName }
  });
}

export async function sendInvitationEmail(
  to: string,
  recipientName: string,
  teamName: string,
  inviterName: string,
  token?: string
) {
  // Create a proper invitation link using the token if provided
  const inviteLink = token 
    ? `${window.location.origin}/invitations/${token}`
    : `${window.location.origin}/login`;
  
  return sendEmail({
    to,
    subject: `You've been invited to join ${teamName} on ShiftNapse`,
    templateName: 'invitation',
    templateData: { recipientName, teamName, inviterName, inviteLink }
  });
}

export async function sendScheduleNotification(
  to: string,
  recipientName: string,
  schedulePeriod: string,
  action: 'open' | 'closed' | 'published',
  dueDate?: string
) {
  const scheduleLink = `${window.location.origin}/schedule/${schedulePeriod}`;
  
  let subject = '';
  switch(action) {
    case 'open':
      subject = `Schedule preferences are now open for ${schedulePeriod}`;
      break;
    case 'closed':
      subject = `Schedule preferences are now closed for ${schedulePeriod}`;
      break;
    case 'published':
      subject = `The schedule for ${schedulePeriod} has been published`;
      break;
    default:
      subject = `Schedule update for ${schedulePeriod}`;
  }
  
  return sendEmail({
    to,
    subject,
    templateName: 'schedule-notification',
    templateData: { recipientName, schedulePeriod, action, dueDate, scheduleLink }
  });
} 